import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
    Button, Dialog, DialogContent,
    DialogActions, makeStyles,
} from '@material-ui/core';
import StringUtils from 'lib/StringUtils';
import ButtonStyles from 'styles/theme/Button';
import TextField from '@material-ui/core/TextField';
import DialogAppBar from 'components/widgets/modal/DialogAppBar';

const buttonStyles = makeStyles((theme) => ButtonStyles.getStyle(theme));
const useStyles = makeStyles((theme) => ({
    AppBar: {
        color: theme.palette.text.white,
        backgroundColor: theme.palette.background.sanMarino,
        '& h4': {
            color: theme.palette.text.white,
        },
    },
    dialogContent: {
        padding: '10px 0',
    },
}));

const AddCategoryDialog = ({
    initialValue,
    isSavingCategory,
    onClose,
    onSaveCategory,
}) => {
    const classes = { ...useStyles(), ...buttonStyles() };
    const [name, setName] = useState(initialValue);

    const saveName = () => {
        onSaveCategory(name);
        setName('');
        onClose();
    };

    return (
        <Dialog
            open
            fullWidth
            maxWidth="sm"
            disableBackdropClick
            disableEscapeKeyDown
            scroll="paper"
            onMouseDown={(e) => e.stopPropagation()}
        >
            <DialogAppBar
                appBarClassName={classes.AppBar}
                title="Category (100 Characters Max)"
                onClose={onClose}
                toolbarSize="md"
            />
            <DialogContent>
                <div className={classes.dialogContent}>
                    <TextField
                        autoFocus
                        label="Name"
                        variant="outlined"
                        value={name}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => setName(e.target.value)}
                        margin="dense"
                        fullWidth
                        inputProps={{ maxLength: 100 }}
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <Button
                    className={classes.containedSecondaryInfo}
                    disabled={StringUtils.isEmpty(name) || isSavingCategory}
                    onClick={saveName}
                >
                    Save
                </Button>
                <Button
                    disabled={isSavingCategory}
                    className={classes.containedError}
                    onClick={onClose}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};

AddCategoryDialog.defaultProps = {
    initialValue: '',
};

AddCategoryDialog.propTypes = {
    initialValue: PropTypes.string,
    isSavingCategory: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSaveCategory: PropTypes.func.isRequired,
};

export default AddCategoryDialog;
